import { defineMessages } from "react-intl";
const messages = defineMessages({
    categoryCardStatusChipLabel: {
        id: "app.admin.aiDiscoverability.result.categoryCard.chip.label",
        defaultMessage: "{change}% since last report",
    },
});
export default messages;
